import { render, staticRenderFns } from "./UniMenu.vue?vue&type=template&id=10090643&scoped=true&"
import script from "./UniMenu.vue?vue&type=script&lang=js&"
export * from "./UniMenu.vue?vue&type=script&lang=js&"
import style0 from "./UniMenu.vue?vue&type=style&index=0&id=10090643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10090643",
  null
  
)

export default component.exports